


export const getUserData = async (userID:string) => {
  console.log("getting user profile data, userID:", userID)

  return new Promise(async (resolve, reject) => {
    
    const { $supabase } = useNuxtApp()
    const supabaseUserData = useSupabaseUserData()

    const { data, error } = await $supabase
      .from('user_profiles')
      .select(`*`)
      .eq('user_id', userID)

    if(error) {
      console.log("Error getting user data:", error)
      // toast.error('Something went wrong - contact support')
    } else {

      console.log('AUTH data:', data);

      // Adjust here to handle potentially multiple records
      if (data && data.length > 0) {
        
        supabaseUserData.value = data[0];
      } else {
        // Handle case where no data is returned
        supabaseUserData.value = {};
      }
    
      console.log("all user data is now:", {...supabaseUserData.value})
  
  
      resolve(supabaseUserData.value)
    }

  })

}

export async function anonymousSignIn() {

  const { $supabase } = useNuxtApp()

  const { data, error } = await $supabase.auth.signInAnonymously()

  if(error) {
    console.log("Error signing in anonymously:", error)
    return null
  } else {
    console.log("Signed in anonymously")
    return data
  }

}


// interface SaveUserDataOptions {
//   showSuccessToast: boolean,
// }

// export async function saveUserData (options:SaveUserDataOptions = {
//   showSuccessToast: false
// }) {
  
//   const { $supabase } = useNuxtApp()
//   const supabaseUser = useSupabaseUser()
//   const supabaseUserData = useSupabaseUserData()

//   if(!supabaseUser.value) {
//     // we've no user, abort
//     console.log("no user, abort")
//     return
//   }
  
//   console.log(`Saving userData for ${supabaseUser.value.id}, options:`, options)
  
//   let newData = {...supabaseUserData.value}
  

//   console.log('newData:', newData);
  

//   const { data, error } = await $supabase
//     .from('profiles_private')
//     .update(newData)
//     .match({id: supabaseUser.value.id })


//   if(error){
//     console.log('error:', error)
//   } else {
//     console.log("user data saved")
//     if(options.showSuccessToast) toast.success("Saved!")
//   }
  
// }

export const signOut = async (options) => {
  console.log("Signing out")

  const { $supabase } = useNuxtApp()
  const supabaseUser = useSupabaseUser()
  const supabaseUserData = useSupabaseUserData()
  const { removeAllListeners } = useRealtimeListeners()
  const company = useCompanyData()

  try {
    const { error } = await $supabase.auth.signOut()

    if(error) throw error
    // clear user data from state
    supabaseUser.value = null
    supabaseUserData.value = null
    company.value = null
    removeAllListeners()
    company.value = null
    console.log("user logged out")
    navigateTo({
      path: options.redirect || '/'
    })
  } catch (error) {
    console.log("Error signing out:", error)
    alert(error)
  }
}